import { useCallback, useEffect, useRef, useState } from "react";
import { staffCall, type StaffMatch } from "@/hooks/use-staff";

/** Save conflicts supersede already-started reactive lookups, including their errors. */
export function useStaffDuplicateMatches(phone:string,nationalId:string,phoneOk:boolean,idOk:boolean){
 const revision=useRef(0);
 const [matches,setMatches]=useState<StaffMatch[]>([]),[matching,setMatching]=useState(false),[lookupError,setLookupError]=useState("");
 const protectSave=useCallback(()=>{revision.current++;setMatching(false)},[]);
 const saveMatches=useCallback((next:StaffMatch[])=>{revision.current++;setMatches(next);setMatching(false);setLookupError("")},[]);
 useEffect(()=>{
  const own=++revision.current;setMatches([]);setLookupError("");setMatching(phoneOk||idOk);
  const timer=setTimeout(async()=>{
   if(!phoneOk&&!idOk)return;
   try{
    const params=new URLSearchParams({phone:phoneOk?phone:"",nationalId:idOk?nationalId:""});
    const result=await staffCall<{matches:StaffMatch[]}>("GET",`/api/staff/employees/match?${params}`);
    if(revision.current===own)setMatches(result.matches);
   }catch(e){if(revision.current===own)setLookupError(e instanceof Error?e.message:String(e))}
   finally{if(revision.current===own)setMatching(false)}
  },250);
  return()=>{clearTimeout(timer);revision.current++};
 },[phone,nationalId,phoneOk,idOk]);
 return{matches,matching,lookupError,protectSave,saveMatches};
}
